(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 767px)';

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  function setAccordionState(heading, open) {
    var col = heading.closest('.tcb-footer__nav-col');
    if (!col) return;
    col.classList.toggle('is-open', open);
    heading.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initFooter(section) {
    if (!section || section.dataset.tcbFooterInit === 'true') return;
    section.dataset.tcbFooterInit = 'true';

    var headings = section.querySelectorAll('.tcb-footer__nav-heading');

    headings.forEach(function (heading) {
      var panelId = heading.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : heading.nextElementSibling;
      if (!panel || !panel.classList.contains('tcb-footer__nav-panel')) return;

      function toggle() {
        if (!isMobile()) return;
        setAccordionState(heading, !heading.closest('.tcb-footer__nav-col').classList.contains('is-open'));
      }

      heading.addEventListener('click', toggle);
      heading.addEventListener('keydown', function (event) {
        if (!isMobile()) return;
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });
    });

    function syncViewport() {
      var mobile = isMobile();
      headings.forEach(function (heading) {
        if (!mobile) {
          setAccordionState(heading, false);
        }
      });
    }

    syncViewport();
    var mq = window.matchMedia(MOBILE_MQ);
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', syncViewport);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(syncViewport);
    }
  }

  function boot() {
    document.querySelectorAll('.tcb-premium-footer').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.tcb-premium-footer') || event.target.closest('.tcb-premium-footer');
    if (section) initFooter(section);
  });
})();
